var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryBackFullIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.092,
    height: 13.501,
    viewBox: "0 0 27.092 13.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-forward",
    "data-name": "Icon ionic-ios-arrow-round-forward",
    d: "M8.36,11.51A.919.919,0,0,1,8.367,12.8L4.092,17.086H27.211a.914.914,0,0,1,0,1.828H4.1L8.374,23.2a.925.925,0,0,1-.007,1.294.91.91,0,0,1-1.287-.007L1.287,18.647h0a1.027,1.027,0,0,1-.19-.288.872.872,0,0,1-.07-.352.916.916,0,0,1,.26-.64l5.794-5.836A.9.9,0,0,1,8.36,11.51Z",
    transform: "translate(-1.027 -11.252)",
    fill: "#5225b5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryBackFullIcon);
export default __webpack_public_path__ + "static/media/PrimaryBackFullIcon.8192dca819ca3d674f9a7fa7e2d004c1.svg";
export { ForwardRef as ReactComponent };